var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoBlack({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 26.5625C21.8858 26.5625 27.0625 21.3858 27.0625 15C27.0625 8.61421 21.8858 3.4375 15.5 3.4375C9.11421 3.4375 3.9375 8.61421 3.9375 15C3.9375 21.3858 9.11421 26.5625 15.5 26.5625Z",
    stroke: "black",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 14.7656V21.0156",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 12.1094C16.3629 12.1094 17.0625 11.4098 17.0625 10.5469C17.0625 9.68393 16.3629 8.98438 15.5 8.98438C14.6371 8.98438 13.9375 9.68393 13.9375 10.5469C13.9375 11.4098 14.6371 12.1094 15.5 12.1094Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoBlack);
export default __webpack_public_path__ + "static/media/Info_black.809f886faef48e09b12eeb7b9cbe1573.svg";
export { ForwardRef as ReactComponent };